import api from './api';

export const syncProduct = async (productId, storeIds) => {
  const { data } = await api.post(`/sync/product/${productId}`, {
    store_ids: storeIds,
  });
  return data;
};

export const pushProduct = async (productId, storeIds) => {
  const { data } = await api.post(`/sync/push/${productId}`, {
    store_ids: storeIds,
  });
  return data;
};

export const bulkSync = async ({ productIds, storeIds, all = false, includeUnlinked = false } = {}) => {
  const payload = { store_ids: storeIds };
  if (all) {
    payload.all = true;
  } else {
    payload.product_ids = productIds;
  }
  if (includeUnlinked) payload.include_unlinked = true;

  const { data } = await api.post('/sync/bulk', payload);
  return data;
};

export const getSyncStatus = async () => {
  const { data } = await api.get('/sync/status');
  return data;
};

export const pushFabricsAndSync = async ({ patternIds, productIds }) => {
  const { data } = await api.post('/sync/push-fabrics-and-sync', { pattern_ids: patternIds, product_ids: productIds });
  return data;
};

export const syncProductFabrics = async (productId) => {
  const { data } = await api.post(`/sync/product/${productId}/fabrics`);
  return data;
};
